// pl_pms_personal_dashboard.ts
// Tłumaczenia dla PersonalDashboard.tsx

export const plPmsPersonalDashboard = {

  // ── Powitania ─────────────────────────────────────────────────────────────
  greetings: {
    morning:   "Dzień dobry",
    afternoon: "Dzień dobry",
    evening:   "Dobry wieczór",
  },

  // ── Sekcje widgety ────────────────────────────────────────────────────────
  sections: {
    liveActivity:   "Aktywność na żywo",
    housekeepingQueue:"Kolejka housekeepingu",
    openIncidents:  "Otwarte zdarzenia",
    handover:       "Przekazanie",
    finance:        "Finanse",
    activity:       "Aktywność",
    operations:     "Operacje",
    maintenance:    "Konserwacja",
    guests:         "Goście",
  },

  // ── Pasek narzędzi ────────────────────────────────────────────────────────
  toolbar: {
    customize: "Dostosuj",
    done:      "Gotowe",
    enter:     "Wejdź",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    arrivalToday:           "Przyjazd dziś",
    arrivalsToday:          "Przyjazdy dziś",
    assignedToHousekeeping: "Przypisane do housekeepingu",
    needsCleaning:          "Wymaga sprzątania",
    occupancy:              "Obłożenie",
    revenue:                "Przychód",
    openIssues:             "Otwarte problemy",
    noCriticalIssues:       "Brak krytycznych problemów",
    noPickupData:           "Brak danych pickup",
    noRevenueData:          "Brak danych o przychodach",
    noRevenueHistory:       "Brak historii przychodów",
    noLinkedIncident:       "Brak powiązanego zdarzenia do przypisania",
    noLinkedIncidentResolve:"Brak powiązanego zdarzenia do rozwiązania",
  },

  // ── Przekazanie ───────────────────────────────────────────────────────────
  handover: {
    acknowledged: "Przekazanie potwierdzone",
    noteAdded:    "Notatka przekazania dodana",
    markedResolved:"Oznaczone jako rozwiązane",
  },

} as const;

export default plPmsPersonalDashboard;
